import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/bad-qr',
        component: () => import('../views/login/BadQr')
    },
    {
        path: '/qr',
        component: () => import('../views/login/QRHandlingView')
    },
    {
        path: '/signup',
        component: () => import('../views/login/Signup')
    },
    {
        path: '/insurance',
        component: () => import('../views/insurance/Insurance.vue')
    },
    {
        path: '/catering/:order',
        component: () => import('@/views/catering/CateringOrder.vue')
    },
    {
        path: '/status/:type',
        component: () => import('../views/login/Status')
    },
    {
        path: '/reset/:token',
        component: () => import('../views/reset/Reset')
    },
    {
        path: '/transaction/finished',
        component: () => import('../views/transaction/TransactionFinished')
    },
    {
        path: '/apply/:sid/:uuid',
        component: () => import('@/views/ParentApply/ParentApply')
    },
    {
        path: '/nova/:step',
        component: () => import('@/views/nova/NovaSchool')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    uplicateNavigationPolicy: 'ignore'
})
export default router
